import { styled } from '@mui/material/styles'
import { FormControl } from '@mui/material'

export const InputFormOutlined = styled(FormControl)({
    fontSize: 12,

    '&.MuiFormControl-root': {
        width: '20rem',
        margin: 0,
        fontSize: 12,
    },

    '& label.Mui-focused': {
        color: '#A69478',
    },

    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#707070',
        },

        '&.Mui-focused fieldset': {
            borderColor: '#A69478',
        },
    },

    '& .MuiInputBase-input': {
        fontSize: '14px',
    },

    '& .MuiFormLabel-root': {
        fontFamily: 'Open Sans',
        transform: 'translate(14px, 9px) scale(1)',

        '&.Mui-focused': {
            background: '#fff',
            transform: 'translate(14px, -9px) scale(0.75)',
        },

        '&.MuiInputLabel-shrink': {
            background: '#fff',
            transform: 'translate(14px, -9px) scale(0.75)',
        },
    },
})
